const module = { name: 'Fandango/util', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_dtmData } from 'require-core';

const { dtmData } = Fandango_dtmData;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_sanitizer as sanitizer } from 'require-core';



const RegExes = {
    DD_MM_YYYY: /^([0-3]?\d)-([01]?\d)-([12]\d{3})\b/,
    YYYY_MM_DD: /^([12]\d{3})-([01]?\d)-([0-3]?\d)\b/,
    MONTH_DD_YYYY: /^([a-z]+) +([0-3]?\d),? +([12]\d{3})\b/i,
    MON_DD_YYYY: /\b([a-z]{3}) +([0-3]?\d) +([12]\d{3})\b/i,
    FANDANGO_DOMAIN: /^(?:(?:https?:)?\/\/)?[a-z0-9_.-]+\.fandango\.co\.uk(?:[/?]|$)/i,
}


const __mockable__ = {
    now() {
        return new Date();
    },
}
function toDate(value) {
    if (typeof value !== 'string') {
        const now = __mockable__.now();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
    let m = value.match(RegExes.DD_MM_YYYY);
    if (m) {
        return new Date(m[3], m[2] - 1, m[1]);
    }
    m = value.match(RegExes.MONTH_DD_YYYY) || value.match(RegExes.MON_DD_YYYY);
    if (m) {
        return new Date(m[1] + '/' + m[2] + '/' + m[3]);
    }
    m = value.match(RegExes.YYYY_MM_DD);
    if (m) {
        return new Date(m[1], m[2] - 1, m[3]);
    }
    return new Date(value);
}
function zeroPad(value, length) {
    length = length || 2;
    value = '' + value;
    while (value.length < length) {
        value = '0' + value;
    }
    return value;
}
function formatDate(value) {
    if (typeof value === 'string') {
        value = toDate(value);
        if (isNaN(value.getTime())) {
            return '';
        }
    }
    else if (!value || !value.getFullYear) {
        return '';
    }
    return value.getFullYear() + '-' + zeroPad(value.getMonth() + 1) + '-' + zeroPad(value.getDate());
}
function formatDateMonthDDYYYY(date) {
    if (!date) {
        return '';
    }
    if (typeof date !== 'object') {
        date = new Date(date);
    }
    const monthNames = [
        'January', 'February', 'March',
        'April', 'May', 'June', 'July',
        'August', 'September', 'October',
        'November', 'December'
    ];
    return monthNames[date.getMonth()] + '  ' + date.getDate() + ', ' + date.getFullYear();
}
function formatDateweekDayMMMDD(date) {
    if (!date) {
        return '';
    }
    if (typeof date !== 'object') {
        date = toDate(date);
    }
    const monthNames = [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sept', 'Oct',
        'Nov', 'Dec'
    ];
    const weekdays = [
        'Monday', 'Tuesday',
        'Wednesday', 'Thursday',
        'Friday', 'Saturday',
        'Sunday'
    ];
    return weekdays[date.getDay() - 1] + ', ' + monthNames[date.getMonth()] + ' ' + date.getDate();
}
function isWithinViewport(el, offset) {
    const rect = el.getBoundingClientRect();
    return (rect.bottom <= document.documentElement.clientHeight + offset &&
        rect.right <= document.documentElement.clientWidth + offset);
}
function debounce(interval, el, opts, cb) {
    if (!interval || !Number(interval)) {
        return null;
    }
    let timeout;
    return function () {
        const _this = this;
        const _arguments = arguments;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            cb.apply(_this, [el, opts, _arguments]);
        }, interval);
    };
}


const defaultLazyloadOptions = {
    container: 'fd-lazy-container',
    dataAttr: 'data-fd-lazy-image',
    viewPortOffset: 100,
    debounce: 100,
    useViewport: true
}
function setBgImage(image, dataAttrName) {
    if (image.getAttribute(dataAttrName)) {
        image.style.backgroundImage = 'url(' + image.getAttribute(dataAttrName) + ')';
        image.removeAttribute(dataAttrName);
    }
}
function lazyLoad(options) {
    options = Object.assign({}, defaultLazyloadOptions, options);
    const $lazyContainers = $('.' + options.container);
    if (!$lazyContainers) {
        return;
    }
    $.each($lazyContainers, (index, container) => {
        function loadImages() {
            if (images.length === 0) {
                container.removeEventListener('scroll', loadImagesDebounced);
                $(container).removeClass(options.container);
                if ($('.' + options.container).length === 0) {
                    window.removeEventListener('scroll', loadImagesDebounced);
                }
                return;
            }
            for (let index = images.length - 1; index >= 0; index--) {
                const image = images[index];
                if (!options.useViewport || isWithinViewport(image, options.viewPortOffset)) {
                    setBgImage(image, options.dataAttr);
                    images.splice(index, 1);
                }
            }
        }
        const images = $(container).find('[' + options.dataAttr + ']');
        if (!images.length) {
            return;
        }
        const loadImagesDebounced = debounce(options.debounce, container, options, loadImages);
        container.addEventListener('scroll', loadImagesDebounced);
        window.addEventListener('scroll', loadImagesDebounced);
        if (options.useViewport) {
            loadImages();
        }
    });
}
function getLongDateString(shortDateString) {
    if (!shortDateString) {
        return '';
    }
    const date = new Date(shortDateString);
    const timezoneOffset = date.getTimezoneOffset();
    date.setUTCMinutes(timezoneOffset);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    const dateString = date.toLocaleDateString('en-us', options);
    return dateString;
}
function navigate(url) {
    if (!url) {
        return;
    }
    function isFandangoDomain(url) {
        return RegExes.FANDANGO_DOMAIN.test(url);
    }
    function isRelativeUrl(url) {
        return url && url.indexOf('//') === -1;
    }
    if (!isFandangoDomain(url) && !isRelativeUrl(url)) {
        return;
    }
    window.location.assign(sanitizer.url(url));
}
function track(key, dtmUpdates) {
    if (!window._satellite || !window._satellite.track || !key) {
        return;
    }
    if (dtmUpdates && typeof dtmUpdates === 'object') {
        Object.assign(dtmData || {}, dtmUpdates);
    }
    window._satellite.track(key);
}
function extendLegacy(publicInterface, sectionName) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[sectionName]) {
        Fandango[sectionName] = publicInterface;
    }
}
module.exports = {
    __mockable__,
    debounce,
    formatDate,
    formatDateMonthDDYYYY,
    getLongDateString,
    isWithinViewport,
    lazyLoad,
    navigate,
    toDate,
    track,
    weekDayMMMDD: formatDateweekDayMMMDD
};
extendLegacy(module.exports, 'util');
export default module.exports;